import { useState } from 'react';
import classNames from 'classnames';

interface NotificationBannerProps {
	message: string;
	type?: 'info' | 'warning' | 'success';
	onClose?: () => void;
	button?: React.ReactNode;
}

export const NotificationBanner = ({ message, type = 'info', onClose, button }: NotificationBannerProps) => {
	const [isVisible, setIsVisible] = useState(true);

	if (!isVisible) return null;

	return (
		<div className={classNames(
			'w-full text-white',
			type === 'info' && 'bg-brand-green',
			type === 'warning' && 'bg-[#E66741]',
		)}>
			<div className="px-3 md:px-5 py-3 md:py-4 flex items-center gap-2.5 md:gap-5">
				{type === 'info' ? (
					<svg className="min-w-5 w-5 h-5 md:min-w-5 md:w-8 md:h-8" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="16" cy="16" r="16" fill="#FEF866"/>
						<path d="M16 9.25V17.25" stroke="#203B3F" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"/>
						<circle cx="16" cy="22" r="1.75" fill="#203B3F" />
					</svg>
				) : (
					<svg className="min-w-5 w-5 h-5 md:min-w-5 md:w-8 md:h-8" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="16" cy="16" r="16" fill="white"/>
						<path d="M16 9.25V17.25" stroke="#E66741" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"/>
						<circle cx="16" cy="22" r="1.75" fill="#E66741" />
					</svg>
				)}
				<div className="text-[11px]/[1.1] font-medium block md:hidden flex-wrap items-center w-full">
					{message}
					{button && (
						button
					)}
				</div>
				<div className="w-full hidden md:flex items-center">
					<div className="text-base font-medium mb-0 pr-2 flex-grow">{message}</div>
					{button && (
						<div className="flex-shrink-0">
							{button}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
